<div class="sorting-toggle">
  <mat-select
    appSelect
    [noIcon]="true"
    [(value)]="sortType"
    (selectionChange)="setSortby(sortType)"
    id="sort-by-select"
    aria-label="Sort by:"
    panelClass="sort-select"
    [hideSingleSelectionIndicator]="true"
  >
    @for (option of selectableFilters; track option) {
      <mat-option [value]="option.sortType" class="sort-options">
        <span>{{ option.title | translate }}</span>
        @if (option.icon !== 'ico-gbp') {
          <i [ngClass]="option.icon"></i>
        }
        @if (option.icon === 'ico-gbp') {
          <img
            alt=""
            src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/filter-coin-icon.svg"
            class="coin-svg"
          />
        }
      </mat-option>
    }
  </mat-select>
</div>
